import classNames from 'classnames';
import styled from 'styled-components';

import type { TypographyVariant } from '@sorare/core/src/atoms/typography';
import { BodyM, BodyS } from '@sorare/core/src/atoms/typography';
import type { Props as UseAmountWithConversionProps } from '@sorare/core/src/hooks/useAmountWithConversion';
import { useAmountWithConversion } from '@sorare/core/src/hooks/useAmountWithConversion';
import type { Color } from '@sorare/core/src/style/types';

type Props = UseAmountWithConversionProps & {
  color?: Color;
  bold?: boolean;
  hideExponent?: boolean;
  inline?: boolean;
  reverse?: boolean;
  MainAmountComponent?: TypographyVariant;
};

const Root = styled.div<{ inline?: boolean }>`
  &.isInline {
    display: flex;
    gap: var(--unit);
    flex-wrap: wrap;
    align-items: baseline;

    &.reverse {
      flex-direction: row-reverse;
    }
  }
`;

export const PaymentBoxAmountWithConversion = ({
  bold = false,
  color,
  hideExponent = false,
  inline,
  reverse,
  MainAmountComponent = BodyM,
  ...props
}: Props) => {
  const { main, exponent } = useAmountWithConversion(props);

  return (
    <Root
      className={classNames({ isInline: inline, reverse, 'text-right': true })}
    >
      <MainAmountComponent bold={bold} color={color || 'var(--c-white)'}>
        {main}
      </MainAmountComponent>
      {!hideExponent && !!exponent && (
        <BodyS color={color || 'var(--c-nd-600)'}>{exponent}</BodyS>
      )}
    </Root>
  );
};
